import PlusCircleOutlineIcon from 'mdi-react/PlusCircleOutlineIcon'
import React, { ReactNode } from 'react'

import { Button, createStyles, Theme } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

const AddItem: React.SFC<FullAddItemButtonProps> = ({ children, label, classes, onClick }) => {
  return (
    <Button aria-label={label} onClick={onClick} variant="outlined" className={classes.button}>
      <PlusCircleOutlineIcon className={classes.addIcon} />
      <span className={classes.buttonLabel}>{children}</span>
    </Button>
  )
}

type FullAddItemButtonProps = AddItemButtonProps & WithStyles<typeof styles>

export type AddItemButtonProps = {
  label: string
  children: ReactNode
  onClick: () => any
}

const styles = ({ spacing, palette }: Theme) =>
  createStyles({
    buttonLabel: {
      marginLeft: spacing(),
    },
    button: {
      marginTop: spacing(2),
      padding: spacing(1),
      display: 'flex',
      boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.2)',
      marginLeft: spacing(1),
      marginRight: spacing(1),
    },
    addIcon: {
      fill: palette.primary.main,
    },
  })

export default withStyles(styles)(AddItem)
